import Service from '@ember/service';

import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { syncResolved } from 'rise-ui/utils/promise.js';

export default class CatalogThemesService extends Service {
  @service ssr;
  @service shoebox;
  @service store;

  @tracked themes = [];

  fetchCatalogThemes() {
    return this.store.findAll('catalog-theme');
  }

  async getThemes() {
    if (!this._catalogThemesPromise) {
      let catalogThemes;
      if (this.ssr.isSsr) {
        catalogThemes = this.fetchCatalogThemes().then(catalogThemes =>
          this.shoebox.putRecords('catalog-themes', catalogThemes)
        );
        this.ssr.deferRendering(catalogThemes);
      }
      this._catalogThemesPromise = catalogThemes = catalogThemes
        || syncResolved(this.shoebox.retrieveRecords(
          'catalog-themes', 'catalog-theme'
        ))
        || this.fetchCatalogThemes();
      catalogThemes.then(catalogThemes =>
        this.themes = this._getThemes(catalogThemes)
      ).catch(() => {});
    }
    return this._getThemes(await this._catalogThemesPromise);
  }

  _getThemes(catalogThemes) {
    return catalogThemes?.map(({ theme }) => theme);
  }
}
